import { AdminService } from './../../_services/admin.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-email-list',
  templateUrl: './progress-email-list.component.html',
  styleUrls: ['./progress-email-list.component.css']
})
export class ProgressEmailListComponent implements OnInit {
  dataList =[]
  loading = false
  dtOptions: DataTables.Settings = {}
  constructor(private adminService:AdminService) { }

  ngOnInit(): void {
    this.loading=true
    this.adminService.getProgressEmailList().subscribe(
      x=>{
        this.dataList=x
        this.loading=false
      }
    )
  }
  recompute(){

    this.loading=true
    this.adminService.getRecomputeProgress().subscribe(
      x=>{
        this.dataList=x
        this.loading=false
      }
    )
  }

  testSend(mail:string){
    this.adminService.testSend(mail).subscribe(
      x=>{
        this.loading=false
      }
    )
  }
}
